import React, { useState, useContext, useEffect } from 'react';
import Application from "../../../StateContext/Application";
import { Form } from 'react-router-dom';

const CreateRoles = () => {
  const [roleName, setRoleName] = useState({
    Department_ID:"",
    Rolename:''
  });
  const [options, setOptions] = useState([]);
  const [show, setshow] = useState(true)
  const [DepartmentList, SetDepartment] = useState([])
  const [menu, setmenu] = useState({})
  const statecalls = useContext(Application);
  const { Usermenu, Roles, DepartmentHandler } = statecalls;

  useEffect(() => {
    async function getmenus() {
      try {
        let menu = await Usermenu();
        let department = await DepartmentHandler('view', null, null);
        SetDepartment(department);
        setOptions(Array.isArray(menu.result) ? menu.result : []);
      } catch (error) {
        console.error(error);
      }
    }
    getmenus()
  }, [])
  
  async function objectpusher(menuname, access) {
    try {
      const updatedMenu = { ...menu };
      if (!Array.isArray(updatedMenu[menuname])) {
        updatedMenu[menuname] = [access];
      } else {
        updatedMenu[menuname] = [...updatedMenu[menuname], access];
      }
      setmenu(updatedMenu);
      console.log(updatedMenu);
    } catch (error) {
      console.error(error);
    }
  }


  const rolecreation = async () => {
    try {
      alert("Role Created Successfully")
      let condition = await Roles('CreateRole', roleName, menu);
      setshow(condition);
    } catch (error) {
      console.error(error);
    }
  }
  

  return (
    <div className="mx-5">

      <Form onSubmit={rolecreation}>

        <div className="">
          <div>
            <label>Select Department</label>
            <select
              className="form-control"
              id='Department_ID'
              onChange={(e)=>{setRoleName({...roleName,[e.target.id]:e.target.value})}}
            >
              <option>Select Department</option>
              {DepartmentList.map((e) => {
                return (
                  <option key={e.Department_ID} value={e.Department_ID}>
                    {e.Department_Name}
                  </option>
                )
              })}
            </select>
          </div>
          <div>
            <label>Role Name</label>
            <input
              type="text"
              className="form-control my-3"
              placeholder="Enter Role Name Here"
              id='Rolename'
              value={roleName.Rolename}
              onChange={(e)=>{setRoleName({...roleName,[e.target.id]:e.target.value})}}
              required
            />
          </div>
          <div>


            {show ? options?.map((e,key) => {
              if (e.Summenuid === 0) {
                return (
                  <>
                    <div key={key} className="accordion" id="accordionPanelsStayOpenExample">
                      <div className="accordion-item" >
                        <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                          <button style={{ backgroundColor: '#cfe2ff' }} className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                            {e.Menu_Name}
                          </button>
                        </h2>
                        <b>{e.Menu_Name}</b>
                        <div style={{ display: 'flex' }}>
                          <span className='mx-2'><b>Create</b><input type='checkbox' onClick={() => objectpusher(e.Menu_ID, 'create')} /></span>
                          <span className='mx-2'><b>Read</b><input type='checkbox' onClick={() => objectpusher(e.Menu_ID, 'Read')} /></span>
                          <span className='mx-2'><b>Edit</b><input type='checkbox' onClick={() => objectpusher(e.Menu_ID, 'Edit')} /></span>
                          <span className='mx-2'><b>Delete</b><input type='checkbox' onClick={() => objectpusher(e.Menu_ID, 'Delete')} /></span>
                        </div>
                        <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
                          <div className="accordion-body">
                            {options?.map((x,index) => {
                              if (e.Menu_ID === x.Summenuid) {
                                return (
                                  <div key={index} style={{ backgroundColor: 'lemonchiffon', border: 'black 2px solid' }}>
                                    <label> {x.Menu_Name}</label>
                                    <div style={{ display: 'flex' }}>
                                      <span className='mx-2'><b>Create</b><input type='checkbox' onClick={() => objectpusher(x.Menu_ID, 'create')} /></span>
                                      <span className='mx-2'><b>Read</b><input type='checkbox' onClick={() => objectpusher(x.Menu_ID, 'Read')} /></span>
                                      <span className='mx-2'><b>Edit</b><input type='checkbox' onClick={() => objectpusher(x.Menu_ID, 'Edit')} /></span>
                                      <span className='mx-2'><b>Delete</b><input type='checkbox' onClick={() => objectpusher(x.Menu_ID, 'Delete')} /></span>
                                    </div>
                                  </div>
                                )
                              }

                            })}


                          </div>
                        </div>
                      </div>
                    </div>
                    <br />
                  </>
                )
              }

            }
            ) : null}
          </div>
          <button className='btn btn-primary my-2' type='submit'  style={{backgroundColor:"#e73d26",border:"none"}}>Create Role</button>
        </div>
      </Form>




    </div>
  );
};

export default CreateRoles;
